import { useEffect } from "react";
import { AppRoutes } from "../types/enums";
import { useNavigate } from "react-router-dom";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";
import { useLogout } from "./useLogout";

type Props = {
  error: FetchBaseQueryError | SerializedError | undefined;
  redirect?: AppRoutes;
  withLogout?: boolean;
};
export const useNotFoundRedirect = ({
  error,
  redirect = AppRoutes.CAMPAIGNS,
  withLogout,
}: Props) => {
  const logout = useLogout();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      error &&
      "status" in error &&
      (error.status === 404 || error.status === 422)
    ) {
      if (withLogout) {
        logout();
      } else {
        navigate(redirect, { replace: true });
      }
    }
  }, [error]);
};
